import { Button } from '@cian/ui-kit/button';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { SearchResultsTooltip } from 'shared/components/SearchResultsTooltip';
import { useAppDispatch, useShowSearchMetaTooltip } from 'shared/hooks';
import { applyFilters } from 'shared/thunks/filters';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { trackSearchButtonClick } from './tracking';
import { selectIsGeoMetaRefreshing, selectQuerystring } from 'shared/selectors/searchMeta';

export const ApplyFiltersButtonContainer: FC = () => {
  const {
    custom: { applyFilterAfterChange },
  } = useApplicationContext();

  const dispatch = useAppDispatch();

  const isGeoMetaRefreshing = useSelector(selectIsGeoMetaRefreshing);

  const queryString = useSelector(selectQuerystring);

  const handleApplyButtonClick = useCallback(() => {
    dispatch(applyFilters());

    trackSearchButtonClick(queryString);
  }, [dispatch, queryString]);

  const showSearchMetaTooltip = useShowSearchMetaTooltip('geo');

  if (applyFilterAfterChange) {
    return null;
  }

  return (
    <SearchResultsTooltip placement="bottom-start" open={showSearchMetaTooltip}>
      <Button
        data-name="ApplyFiltersButton"
        theme="fill_primary"
        size="XS"
        onClick={handleApplyButtonClick}
        loading={isGeoMetaRefreshing}
      >
        Найти
      </Button>
    </SearchResultsTooltip>
  );
};
